var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"placeholder":"Enter search query","prepend-icon":"search","width":"600"},on:{"change":_vm.search},model:{value:(_vm.query),callback:function ($$v) {_vm.query=$$v},expression:"query"}})}
var staticRenderFns = []

export { render, staticRenderFns }